export default "__VITE_ASSET__23fc6a3d__"